<template>
  <slot />
</template>

<script setup lang="ts">
const { seo } = useSeo()

useSeoMeta({
  title: () => seo.value.title,
  description: () => seo.value.description,
  ogSiteName: () => seo.value.title,
  ogImage: () => seo.value.ogImage,
})

useHead({
  title: () => seo.value.title,
})

// todo: need to investigate why this is not working as expected
// defineOgImage({
//   url: seo.value.ogImage,
// })
</script>
